import { render, staticRenderFns } from "./IndustrialPropertyFiles.vue?vue&type=template&id=4a1660d0&scoped=true"
import script from "./IndustrialPropertyFiles.vue?vue&type=script&lang=js"
export * from "./IndustrialPropertyFiles.vue?vue&type=script&lang=js"
import style0 from "./IndustrialPropertyFiles.vue?vue&type=style&index=0&id=4a1660d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1660d0",
  null
  
)

export default component.exports